import{a as o}from"./chunk-RAAYCPUM.js";function r(...e){return o(t,e)}var t=e=>e.toLowerCase();export{r as a};
